<template>
    <div id="pz">
     <div class="dokpz">
        <div class="title">{{ title }}</div>
	<div class="items">
		<div id='container' class='e-resizable'>
     		<ejs-grid ref="grid" :dataSource="data2" :allowPaging="false" :pageSettings="pageSettings" :allowSorting="true" :allowGrouping="false" :selectionOptions="selectionOptions" :rowSelected="rowSelected" :rowDeselected="rowSelected" :allowTextWrap='true' locale='pl-PL' :allowFiltering="true" :filterSettings="filterOptions" :rowHeight="80" height="100%" width="100%" groupSettings="groupSettings" :dataBound='dataBound' :childGrid="childGrid" :detailDataBound='onDetailDataBound'> 
			<e-columns>
				<e-column field='id' headerText='Id zlecenia' width='50' :allowFiltering="false"></e-column>
				<e-column field='typ_zlecenia' headerText='Typ zlecenia' width='20' :visible="false"></e-column>
				<e-column field='rodzaj_zlecenia' headerText='Rodzaj zlecenia' width='100'></e-column>
				<e-column field='data_realizacji' headerText='Data realizacji' type='date' format='yyyy-MM-dd' width='80' :visible="false"></e-column>
				<e-column field='kontrahent' headerText='Kontrahent' width='200'></e-column>
				<e-column field='numerDokumentuMagazynowego' headerText='Numer dokumentu' width='90' :visible="false"></e-column>
                                <e-column field='produkt' headerText='Produkt' width='100'></e-column>
                                <e-column field='surowiec' headerText='Surowiec' width='110' :visible="false"></e-column>
            			<!--<e-column type='checkbox' width='50'></e-column>-->
			</e-columns>
		</ejs-grid>
		</div>
	</div>
     </div>
     <div class="wleft">
        <button class="wlabel">WRÓĆ</button>
    </div>
    <div class="wcenter">
        <button class="wlabel"> Lista dokumentów PW </button>
    </div>
    <div class="wright">
	<button class="wlabel"> WYBIERZ ODSTORTY </button>
    </div>
    </div>
</template>

<script>

import Vue from "vue";
import { GridPlugin, Page, Sort, Filter, Group, DetailRow } from "@syncfusion/ej2-vue-grids";
//import { L10n, setCulture } from '@syncfusion/ej2-base';
import { dokumenty_pz } from "./panel1_dane.js";
import * as CONFIG from "./config.js";
import axios from "axios";
import { polish } from "./polish.js";
import Storage from "./Storage";

//setCulture('pl-PL');

axios.defaults.withCredentials = false;

Vue.use(GridPlugin);

var subdata = [];

var initial = true;
export default {
  name: "zlecenia",
  props: {
    groupTitle: String,
    dataLoading: Boolean,
  },
  data: () => ({
	//data: dokumenty_pz.items,
	data: [],
	data2: [],
	url: "/agent/GALEK.Magazyn/GetZlecenia",
	title: "ODSORTY > ZLECENIA",
	x: 1,
        pageSettings: { pageSize: 5 },
        selectionOptions: { allowColumnSelection: false, type: "Single" },
	//groupSettings: { columns: ['id','numerDokumentuMagazynowego','surowiec'] },
	gitem: { },
	filterOptions: {
        type: 'Menu',
        operators: {
          stringOperator: [
            { value: 'startsWith', text:'startsWith' },
            { value: 'endsWith', text:'endsWith' },
            { value: 'contains', text:'contains' }
          ],
        }
	},
	jwt: "",
	childGrid: { 
                allowGrouping: false,
                allowPaging: false,
                queryString: "id",
                columns: [
                        //{ field:'id_zlecenia', headerText:'Id zlecenia', width:150 },
                        //{ field:'rodzaj_zlecenia', headerText:'Rodzaj zlecenia', width:200 },
                        //{ field:'kontrahent', headerText:'Kontrahent', width:50 },
                        { field:'data_realizacji', headerText:'Data realizacji', type:'date', format:'yyyy-MM-dd', width: 120 },
                        { field:'numerDokumentuMagazynowego', headerText:'Numer dokumentu', width: 200 },
                        //{ field:'produkt', headerText:'Produkt', width: 50 },
                        { field:'surowiec', headerText:'Surowiec', width:210 }
                ],
        },
   }),
   provide: {
	grid: [Page, Sort, Filter, Group, DetailRow]
   },
   methods: { 
	onDetailDataBound(args) {
                args.detailElement.querySelector('.e-grid').ej2_instances[0].dataSource = subdata; // assign data source for child grid.
        },
	dataBound: function() {
		if(initial === true) {
            		//this.$refs.grid.ej2Instances.groupModule.collapseAll();
            		initial = false;
        	}
        	//this.$refs.grid.autoFitColumns();
    	},
	rowSelected(args) {
        	//let selectedrowindex = this.$refs.grid.getSelectedRowIndexes();  // Get the selected row indexes.
        	//alert(selectedrowindex); // To alert the selected row indexes.
        	let selectedrecords = this.$refs.grid.getSelectedRecords();  // Get the selected records.
		if (selectedrecords.length > 0) {
			this.gitem = selectedrecords[0];		
			//alert(JSON.stringify(this.gitem));
		} else {
			this.gitem = {};
		}
	},
	dokpwclick() {
                if (this.gitem && this.gitem.id) {
                        this.$router.push({ path: "/dokumentpwprzyjecie", query: { id_zlecenia: this.gitem.id, prev: "zleceniaodpady" }});
                } else {
                        alert("Nie wybrano elementu do realizacji. Proszę zaznaczyć dokładnie 1 element z listy.");
                }
        },
	forwardclick() {
		//alert("Drukuj");
		if (this.gitem && this.gitem.id) {
			this.$router.push({ path: "/odpady", query: { id_zlecenia: this.gitem.id }});
		} else {
			alert("Nie wybrano elementu do realizacji. Proszę zaznaczyć dokładnie 1 element z listy.");
		}
	},
	wrocclick() {
		this.$router.push({ path: "/main" });
	},
	getData() {
      		return axios
        		.get(CONFIG.API_URL + this.url, {
          		headers: {
            			"Content-Type": "application/x-www-form-urlencoded",
            			"Accept": "application/json",
				"Authorization": "Bearer " +  this.jwt,
          		}
        		})
        		.then(response => {
          			return response.data;
        		})
        		.catch(e => {
          			alert("ERROR" + e);
        		});
	},
   },
   created() {
	var that = this;
	var zlecenia = {};
	Storage.loadJWT("jwt").then(resp => {
		//alert(resp.access_token);
		that.jwt = resp.access_token;
		that.getData().then(data => {
			that.data = data;
			var that_ = that;
                        that.data.forEach(function(elem, index) {
                                if (zlecenia[elem.id] == true) {
                                        subdata.push(elem);
                                } else {
                                        that_.data2.push(elem);
                                        zlecenia[elem.id] = true;
                                }
                        });
		});
	});
   },
   mounted()  {
	var that = this;
	document.querySelector(".wright").addEventListener('click', function() { that.forwardclick(); } );
	document.querySelector(".wleft").addEventListener('click', function() { that.wrocclick(); } );
	document.querySelector(".wcenter").addEventListener('click', function() { that.dokpwclick(); } );

   }
};

</script>

<style>
  @import "../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";

.e-resizable {
  resize: both;
  overflow: auto;
  /*border: 1px solid red;*/
  padding: 1px;
  height: 500px;
  min-height: 550px;
  min-width: 250px;
}

.drukuj {
	width: 100px;
	height: 50px;
	padding-top: 10px;
	text-align: right;
	float: right;
}

.title {
	text-align: left;
	width: 50%;
}
.items {
	float:none;
}
.dokpz {
	float: left;
	width: 96%;
	padding: 2% 2% 0% 2%;
}
.wcenter {
        width: 60%;
        margin-left: 20%;
        margin-right: 20%;
        height: 50px;
        position:fixed;
        bottom: 50px;
}
.wright {
        width: 200px;
        height: 50px;
        position:fixed;
        bottom: 10px;
        right: 10px;
        text-align: right;
        background-color: #FFFFFF;
        /*padding-top: 10px;*/
        float: right;
        margin-top: 40px;
}
.wleft {
        width: 200px;
        height: 50px;
		position:fixed;
        bottom: 10px;
        text-align: left;
        background-color: #FFFFFF;
        float: left;
        margin-top: 40px;
        /*margin-left: 400px;*/
}
.wlabel {
        width: 200px;
        height: 50px;
        position:relative;
        background-color: #FFFFFF;
}

</style>



// WEBPACK FOOTER //
// src/components/ZleceniaOdpady.vue